import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import {
  StyledContentBlock,
  ImageWrapper,
  StyledImage,
  StyledSection,
  Contentwrapper,
  Subtitle,
  Title,
  ImageTitle,
} from './styled';

const Security = ({ template }) => {
  const { messages, locale } = useIntl();

  return (
    <StyledSection>
      <StyledContentBlock>
        <Contentwrapper>
          <Title locale={locale}>
            <FormattedMessage id={`${template}.security.title`} />
          </Title>
          <Subtitle>
            <FormattedMessage id={`${template}.security.paragraph`} />
          </Subtitle>
        </Contentwrapper>
        <ImageWrapper>
          <ImageTitle>Security</ImageTitle>
          <StyledImage
            src={messages[`${template}.security.image.src`]}
            alt={messages[`${template}.security.image.alt`]}
          />
        </ImageWrapper>
      </StyledContentBlock>
    </StyledSection>
  );
};

Security.propTypes = {
  template: PropTypes.string.isRequired,
};

export default Security;
